/*
  File for giving you the correct section for create-crq based on some params.
  It may be worth considering redirects here too. For example, if you try to go to
  'mobile/3' when you haven't filled in section 1 or 2, it could redirect you to
  section 1. The argument for doing it here is we know the dynamic structure of the
  form here and enough enough information to detect if a section is incomplete. Though
  this is obvs up for debate. If we do do this we should disable it on a dev build though!
*/

import React from 'react';
import {
  currentSelectedNetwork,
  getIsOlaCrq,
  getIsInternationalCrq,
  isCrqEmergency,
} from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
import { Redirect } from 'AppSrc/core/components/utility/redirect';
import {
  defaultSectionId,
  getCurrentSectionOrder,
  sectionapproverSkip,
} from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/section-order';
import { createCrqSectionComponents } from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/components';

// getCreateCrqSection returns the form section as the component. In general we assume that this section exists.
// However if we are wrong, we gracefully fall back by redirecting to the first section. The only problem with this
// is getCreateCrqSection has to return a component, so we reuturn this as we do the redirect
const redirectToSection = (redirectFun) => {

  const Redirecting = () => (
    <Redirect
      redirectFun={redirectFun}
    />
  );

  return Redirecting;
};

const getComponentForSectionId = (sectionId) => {
  const component = createCrqSectionComponents[sectionId];
  if (!component) {
    console.error(`Section component not found for sectionId ${sectionId}.`);
  }
  return component;
};


const errorAndRedirect = (navigateToCreateCrqSectionOne) => {
  console.error('Cannot find the correct section for createCrq. Please check the params and that the routing is correct');

  // can't find section, so falling back to sectionOne
  return redirectToSection(navigateToCreateCrqSectionOne);
};


const getCreateCrqSection = (params) => {
  const {
    sectionIndex,
    formData,
    userRoles,
    navigateToCreateCrqSectionOne,
  } = params;

  const selectedNetwork = currentSelectedNetwork(formData);
  // const isOloCrq = getIsOlaCrq(formData);
  const changeDetails = 'CHANGE_DETAILS';
  const isOloByService = formData.dataByFormSectionId[changeDetails] ? formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: Other Licensed Operator (OLO)' || formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: International Other Licensed Operator (OLO)' : null;
  const isOloCrq = getIsOlaCrq(formData) || isOloByService;
  const isIcmCrq = getIsInternationalCrq(formData);
  const isEmergency = isCrqEmergency(formData); // added for Emergency Check


  if (sectionIndex === 0) {
    return getComponentForSectionId(defaultSectionId); // the first section is always the same
  }

  // if section index isn't 0, we should have a network... So something must have gone wrong
  if (!selectedNetwork) {
    return errorAndRedirect(navigateToCreateCrqSectionOne);
  }



  const currentSections = getCurrentSectionOrder({
    network: selectedNetwork,
    userRoles,
    isOloCrq,
    isIcmCrq,
  });
  const sectionId = currentSections[sectionIndex];

  if (!sectionId) {
    // can't locate what section is next? Start at the begining...
    return getComponentForSectionId(defaultSectionId);
  }

  const CurrentSection = getComponentForSectionId(sectionId);
  if (isEmergency) {
    if (selectedNetwork === 'fixed' || isIcmCrq) {
      if (sectionId === 'APPROVERS_SECTION') {
        return getComponentForSectionId(sectionapproverSkip);
      }
    }
  }
  // Emrgency change

  if (CurrentSection) {
    return CurrentSection;
  }


  // can't locate what section is next? Start at the begining...
  return getComponentForSectionId(defaultSectionId);
};

export { getCreateCrqSection };
